module.exports = __webpack_public_path__ + "static/media/movies_light.b916ac24.svg";